import store from "store";
import { beablooApi } from "utils";

const getItemsToDelete = async (houseTypeId) => {
  try {
    const { general: { currentDevelopment } } = store.getState();
    console.log('Fetching items to delete for house type:', houseTypeId);
    const response =  await beablooApi({
      method: 'get',
      route: `/developments/${currentDevelopment.id}/houseTypes/deleteList/${houseTypeId}`,
    })

    if (!response.success) {
      throw new Error('unable to get list of items to delete');
    }
    return response.data;

  } catch (error) {
    console.error('Error fetching items to delete:', error);
    throw new Error('unable to get list of items to delete');
  }
}

const transferHouses = async (payload) => {
  try {
    const { general: { currentDevelopment } } = store.getState();
    const response = await beablooApi({
      method: 'post',
      route: `/developments/${currentDevelopment.id}/houseTypes/transfer`,
      payload: { ...payload }
    });
    if (!response.success) {
      throw new Error('unable to transfer houses');
    }
    return response.data;

  } catch (error) {
    throw new Error('unable to transfer houses');
  }
}

const deletePlotsBatch = async (payload) => {
  try {
    const { general: { currentDevelopment } } = store.getState();
    const response = await beablooApi({
      method: 'post',
      route: `/developments/${currentDevelopment.id}/houseTypes/deletePlotsBatch`,
      payload: { ...payload }
    });
    if (!response.success) {
      throw new Error('unable to delete list of plots');
    }
    return response.data;

  } catch (error) {
    throw new Error('unable to delete list of plots');
  }
}

const houseTypeServices = {
  getItemsToDelete,
  transferHouses,
  deletePlotsBatch
}

export default houseTypeServices;